import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BasketItem, User, UserService } from '@sabstravtech/obtservices/angular';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';

@Component({
  templateUrl: './duplicate-booking-modal.component.html',
  styleUrls: ['./duplicate-booking-modal.component.scss'],
  standalone: false
})
export class DuplicateBookingModalComponent implements OnInit {
  userBooking: BasketItem[] = null;
  displayItinerary = false;

  constructor(
    public activeModal: NgbActiveModal,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    console.log(this.userBooking);
    this.displayItinerary = this.userService.isBasketReplacementUserFavouriteSet();
  }
}

LightningModalTypes.ModalDuplicateBookingComponent.component = DuplicateBookingModalComponent;
